import ConstructionSitesFilters from "@/models/server/ConstructionSitesFilters";

export default class ConstructionSitesDetailedFilters extends ConstructionSitesFilters {

    public siteNumber: string | null = null;

    public siteName: string | null = null;

    public customerNumber: string | null = null;

    public customerName: string | null = null;

    public invoiceReference: string | null = null;

    public externalReference: string | null = null;

    public address: string | null = null;
}